import styled from "styled-components";
import { AuthorizationManagementWrapper } from "@/pages/authorization-management/atom";
import CheckedIcon from "@/assets/images/checked-icon.png";

export const ExpireDate = styled.p`
  margin-top: 4px;
  .left {
    margin-left: 12px;
  }
  .status-text {
    margin-left: 10px;
  }
`;

export const AccountCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 228px;
  height: 94px;
  background: #292b2f;
  border: 1px solid #434447;
  border-radius: 4px;
  padding: 12px;
  color: #d9dfe0;
  gap: 4px;
  .title {
    line-height: 20px;
  }
  .tip {
    font-size: 12px;
    line-height: 17px;
    color: #7a7f80;
  }
  .key {
    min-height: 24px;
    color: #d9dfe0;
    background: #232426;
    border-radius: 4px;
    font-size: 12px;
    line-height: 24px;
    padding-left: 9px;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 20px;
    div {
      position: absolute;
      right: 7px;
      svg {
        color: #9ba2b0;
      }
    }
  }
`;

export const AccountCardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
`;

export const Label = styled.div`
  color: #a8acad;
  font-size: 14px;
  display: flex;
  align-items: center;
  svg {
    margin-left: 4px;
  }
`;

export const Section = styled.div`
  margin-bottom: 30px;
  &.platform {
    ${Label} {
      margin-bottom: 4px;
    }
  }
  .gap-item-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    > div {
      display: flex;
      align-items: center;
    }
    .gap {
      display: inline-block;
      margin-left: 12px;
      color: #4f5051;
      font-size: 10px;
      user-select: none;
    }
  }
`;

export const AuthViewPageWrapper = styled(AuthorizationManagementWrapper)`
  padding: 20px;
  color: #d9dfe0;
`;

export const TableSection = styled(Section)`
  ${Label} {
    margin-bottom: 12px;
  }
  table {
    .ant-table-container {
      border: unset !important;
    }
    .ant-table-cell {
      border-right: 1px solid #343538 !important;
      border-bottom: 1px solid #343538 !important;
      background: #45454a !important;
    }
    .ant-table-cell:last-child {
      background: #232426 !important;
      .ant-checkbox-wrapper {
        color: rgba(255, 255, 255, 0.35);
      }
      .ant-checkbox-wrapper-checked {
        position: relative;
        color: rgba(255, 255, 255, 0.85);
        &:before {
          content: "";
          width: 12px;
          height: 10px;
          top: 50%;
          left: 6px;
          transform: translateY(-50%);
          position: absolute;
          mask: url(${CheckedIcon});
          mask-size: cover;
          background-color: var(--main-color);
          background-size: 100%;
        }
        .ant-checkbox {
          z-index: -1;
          display: unset;
        }
      }
    }
    .ant-checkbox-wrapper {
      cursor: unset;
      pointer-events: none;
      position: relative;
      .ant-checkbox {
        z-index: -1;
        display: none;
      }
    }
  }
`;

export const OperationSection = styled(Section)`
  display: flex;
  justify-content: center;
  gap: 26px;
  .close {
    background: #db3227 !important;
    border-radius: 4px;
    min-width: 136px;
    height: 40px;
    border-color: transparent;
    color: #fff;
  }
  .edit {
    border: 1px solid #5d5f61;
    border-radius: 4px;
    width: 136px;
    height: 40px;
    color: #b4b4b4;
    background: transparent;
    &:hover {
      border: 1px solid #5d5f61 !important;
    }
  }
`;
